import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './context'
import { baseUrl, apiUrl, webAuth } from './delcare'
import UiInput2 from './ui_input2';
import UiButton1 from './ui_button1';
import UiSpinner from './ui_spinner';

const AccountChangePassword = () => {

    const { neonUser, ww, token } = useContext(AppContext)
    const navigate = useNavigate()

    const [password, setPassword] = useState({
        current: "",
        new: "",
        confirm: ""
    })
    const [generalMessage, setGeneralMessage] = useState("")
    const [error, setError] = useState(null)
    const [proceed, setProceed] = useState(false)
    const [loader, setLoader] = useState(false)

    const userChangeHandler = (value, field) => {
        setPassword({
            ...password,
            [field]: value
        })
    }

    const proceedChangePassword = async () => {
        setLoader(true)
        let resp = await fetch(`${apiUrl}/change-password`, {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
                return myHeaders
            })(),
            body: JSON.stringify({
                password: password.new,
                user_id: neonUser.user_id
            })
        })

        if (!resp.ok) {
            setLoader(false)
            return
        }

        resp = await resp.json()

        if (!resp.user_id) {
            setLoader(false)
            setGeneralMessage("Error in proceed password reply from server")
            setError(true)
            return
        }

        setGeneralMessage("Password Changed Successfully")
        setError(false)
        setPassword({ confirm: "", new: "", current: "" })
        setLoader(false)
        window.location.reload()
        return
    }

    const changePassword = async () => {
        setLoader(true)
        setError(null)
        setGeneralMessage("")
        setProceed(false)

        let valid = true
        Object.keys(password).forEach((x) => {
            if ([null, undefined, ""].includes(password[x])) valid = false
        })

        if (!valid) {
            setGeneralMessage("Fields must not be empty.")
            setError(true)
            setLoader(false)
            return
        }

        if (password.new != password.confirm) {
            setGeneralMessage("Confirm and New password did not match.")
            setError(true)
            setLoader(false)
            return
        }

        webAuth.login({
            username: neonUser.email,
            password: password.current,
            realm: 'Username-Password-Authentication',
            onRedirecting: function(done) {
                setProceed(true)
                setLoader(false)
            }
        }, function(err) {
            setGeneralMessage("Current password is wrong.")
            setError(true)
            setLoader(false)
            return
        })
    }

    useEffect(() => {
        if (proceed) {
            proceedChangePassword()
            setProceed(false)
        }
    }, [proceed])

    return (
        <div className={"gap-3 d-flex flex-column " + (ww < 400 ? "px-3 pt-4 " : "p-4")}>
            <div className="d-flex gap-2">
                {["owner"].includes(neonUser.role) &&
                    <div
                        onClick={() => navigate("/account")}
                        className="d-flex gap-2 justify-content-center"
                        style={{ width: 50, height: 50, borderRadius: 25, border: "1px solid lightgray", cursor: "pointer" }}>
                        <img className="align-self-center" src={baseUrl + "/src/back-arrow.png"} style={{ width: 15, height: 15 }} />
                    </div>
                }
                <p className="align-self-center mb-1 fs-4">Change Password</p>
            </div>
            <div style={{ maxWidth: 1600 }}>
                <div className="container1">
                    <div style={{ maxWidth: 500 }}>
                        <div className='row gap-3'>
                            {generalMessage ? <p className={error ? 'text-danger' : error == false ? 'text-success' : ''}>{generalMessage}</p> : null}
                            <div className='col-12'>
                                <p className="poppins mb-1 fw-bold">CURRENT PASSWORD</p>
                                <UiInput2 type="password" field="current" value={password.current} userChangeHandler={userChangeHandler} />
                            </div>
                            <div className='col-12'>
                                <p className="poppins mb-1 fw-bold">NEW PASSWORD</p>
                                <UiInput2 type="password" field="new" value={password.new} userChangeHandler={userChangeHandler} />
                            </div>
                            <div className='col-12'>
                                <p className="poppins mb-1 fw-bold">CONFIRM NEW PASSWORD</p>
                                <UiInput2 type="password" field="confirm" value={password.confirm} userChangeHandler={userChangeHandler} />
                            </div>
                            <div className='col-12 my-3' style={{ maxWidth: 300 }}>
                                {loader ?
                                    <div className="d-flex justify-content-center">
                                        <UiSpinner />
                                    </div>
                                    :
                                    <UiButton1 text="Change Password" submit={changePassword} width={ww < 300 ? (ww - 50) : 250} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountChangePassword